import * as types from 'types/feedItem';
// SAGA

export const postFeedItems = (_feed, feedItems) => ({
    type: types.POST_FEED_ITEMS,
    _feed,
    feedItems
});
